import { render, staticRenderFns } from "./SvgLayered.vue?vue&type=template&id=ff3e3cc6&scoped=true"
import script from "./SvgLayered.vue?vue&type=script&lang=js"
export * from "./SvgLayered.vue?vue&type=script&lang=js"
import style0 from "./SvgLayered.vue?vue&type=style&index=0&id=ff3e3cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3e3cc6",
  null
  
)

export default component.exports